import { render, staticRenderFns } from "./partner_examine_detail_institutions.vue?vue&type=template&id=3528acc2&scoped=true"
import script from "./partner_examine_detail_institutions.vue?vue&type=script&lang=js"
export * from "./partner_examine_detail_institutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3528acc2",
  null
  
)

export default component.exports